module.exports = ".page-content {\r\n\r\n    display: -webkit-box;\r\n\r\n    display: -ms-flexbox;\r\n\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/support/support.component.css
// module id = ./src/app/support/support.component.css
// module chunks = main